import React, {FC, useContext, useEffect, useState} from 'react';
import styles from "../css/Notification.module.css";
import {Icons} from "../../helpers/Icons";
import {notification} from "../../helpers/types";
import Context from "../../helpers/Context";
import {useTranslation} from "react-i18next";

interface IProps
{
    notification: notification;
}

const Notification: FC<IProps> = ({notification}) =>
{
    const {notificationDispatch} = useContext(Context);
    const {t} = useTranslation();

    const [hideMessage, setHideMessage] = useState<boolean>(false);

    const isConnectionError = (message: unknown): boolean =>
    {
        if(message instanceof Error) return /failed to fetch|network|load failed/i.test(message.message);
        if(typeof message === "string") return /failed to fetch|network|load failed/i.test(message);
        if(message && typeof message === "object" && "message" in message)
        {
            return /failed to fetch|network|load failed/i.test(String((message as {message?: unknown}).message ?? ""));
        }
        return false;
    }

    const normalizeMessage = (message: unknown): string =>
    {
        if(notification.type === "error" && isConnectionError(message)) return t("app.backendUnavailable");

        if(typeof message === "string") return message;
        if(message instanceof Error) return message.message || t("app.genericError");
        if(message && typeof message === "object" && "message" in message)
        {
            return String((message as {message?: unknown}).message ?? t("app.genericError"));
        }
        if(message === null || message === undefined) return t("app.genericError");
        return String(message);
    }

    useEffect(() =>
    {
        setInterval(() =>
        {
            handleCloseNotification();
        }, 3000)
    }, []);

    const handleCloseNotification = (): void =>
    {
        setHideMessage(true);

        setInterval(() =>
        {
            notificationDispatch({
                type: "REMOVE_NOTIFICATION",
                id: notification.id
            })
        }, 1000);
    }

    return (
        <div className={`${styles.message_container} ${hideMessage ? styles.hide : ""}`}>
            <div className={styles.message_content_container}>
                <span className={`${styles.message_type} ${styles[notification.type]}`} />

                <div className={styles.message_content}>
                    <div className={styles.message_type_icon}
                         style={{color: notification.type === "error" ? "var(--error)" : notification.type === "warning" ? "var(--warning)" : "var(--success)"}}>
                        <>{Icons[notification.type as keyof Object]}</>
                    </div>

                    <div className={styles.message}>{normalizeMessage(notification.message)}</div>

                    <div className={styles.close} onClick={handleCloseNotification}>{Icons.close}</div>

                </div>
            </div>
            <div className={`${styles.message_timer} ${styles[notification.type]}`} />
        </div>
    );
}

export default Notification;
